<template>
    <div class="de-text-circle" ref="chartDiv">
        <svg width="100%" height="100%" viewBox="0 0 440 440" class="center">
            <g transform="matrix(0,-1,1,0,0,440)">
                <circle cx="220" cy="220" r="170" stroke-width="30" :stroke="circleBackground" fill="none" stroke-dasharray="1069 1069"></circle>
                <circle v-if="percent" cx="220" cy="220" r="170" stroke-width="45" :stroke="circleFrontColor" stroke-linecap="round" fill="none" :stroke-dasharray="percent/100*1069+' 1069'"></circle>
            </g>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'de-text-circle',
    props: {
        percent: {
            type: Number
        },
        circleBackground: {
            type: String
        },
        circleFrontColor: {
            type: String
        }
    }
}
</script>

<style lang="less">

</style>